import React, { useState } from 'react';
import { Gift, ArrowRight, Mail, Package } from 'lucide-react';
import { Button } from '../components/Button';
import { Card, CardContent } from '../components/Card';
import { MiniFAQ } from '../components/MiniFAQ';
const amounts = [25, 50, 75, 100];
export function Cadeaubonnen() {
  const [selectedDigitaal, setSelectedDigitaal] = useState<number>(50);
  const [selectedFysiek, setSelectedFysiek] = useState<number>(50);
  return <div className="container mx-auto px-4 py-12" data-id="element-309">
      <div className="max-w-4xl mx-auto" data-id="element-310">
        <div className="text-center mb-12" data-id="element-311">
          <h1 className="text-3xl md:text-4xl font-bold mb-4" data-id="element-312">Cadeaubonnen</h1>
          <p className="text-xl text-gray-600" data-id="element-313">Geef creativiteit cadeau!</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-12 items-center mb-16" data-id="element-314">
          <div data-id="element-315">
            <h2 className="text-2xl font-bold mb-4" data-id="element-316">Het perfecte geschenk</h2>
            <p className="text-gray-600 mb-6 leading-relaxed" data-id="element-317">
              Op zoek naar een origineel cadeau? Met een cadeaubon van De
              Maekerij geef je een unieke ervaring. De ontvanger kan zelf kiezen
              uit ons uitgebreide aanbod van workshops: van keramiek en
              houtbewerking tot textiel en grafiek.
            </p>
            <ul className="space-y-3" data-id="element-318">
              <li className="flex items-center text-gray-700" data-id="element-319">
                <Gift size={20} className="mr-3 text-gray-400" data-id="element-320" />
                Geldig voor alle workshops
              </li>
              <li className="flex items-center text-gray-700" data-id="element-321">
                <Gift size={20} className="mr-3 text-gray-400" data-id="element-322" />1 jaar geldig
                na aankoop
              </li>
              <li className="flex items-center text-gray-700" data-id="element-323">
                <Gift size={20} className="mr-3 text-gray-400" data-id="element-324" />
                Digitaal verstuurd of feestelijk verpakt
              </li>
              <li className="flex items-center text-gray-700" data-id="element-325">
                <Gift size={20} className="mr-3 text-gray-400" data-id="element-326" />
                Bedrag naar keuze
              </li>
            </ul>
          </div>

          <div className="border-2 border-dashed border-gray-300 h-80 flex items-center justify-center bg-gray-50 rounded-lg" data-id="element-327">
            <span className="text-gray-400" data-id="element-328">Afbeelding cadeaubon</span>
          </div>
        </div>

        {/* Product cards */}
        <h2 className="text-2xl font-bold mb-6" data-id="element-329">Kies jouw cadeaubon</h2>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mb-12" data-id="element-330">
          {/* Digitale bon */}
          <Card variant="outlined" data-id="element-331">
            <CardContent data-id="element-332">
              <div className="border-b border-dashed border-gray-200 h-44 -mx-4 -mt-4 mb-6 flex items-center justify-center bg-gray-50 rounded-t-lg" data-id="element-333">
                <Mail size={40} className="text-gray-300" data-id="element-334" />
              </div>
              <h3 className="text-xl font-bold mb-2" data-id="element-335">Digitale cadeaubon</h3>
              <p className="text-sm text-gray-600 mb-6" data-id="element-336">
                Direct per e-mail verstuurd naar jou of de ontvanger. Ideaal als
                last-minute cadeau. Bevat een unieke code om online te
                verzilveren bij het boeken van een workshop.
              </p>

              <div className="mb-4" data-id="element-337">
                <span className="text-sm font-medium text-gray-700 block mb-2" data-id="element-338">
                  Kies een bedrag
                </span>
                <div className="flex flex-wrap gap-2" data-id="element-339">
                  {amounts.map(amount => <button key={amount} onClick={() => setSelectedDigitaal(amount)} className={`px-4 py-2 rounded-md text-sm font-medium border transition-colors duration-150 focus:outline-none ${selectedDigitaal === amount ? 'bg-gray-800 text-white border-gray-800' : 'bg-white text-gray-700 border-gray-300 hover:bg-gray-50'}`} data-id="element-340">
                      €{amount}
                    </button>)}
                </div>
              </div>

              <div className="flex items-center justify-between pt-4 border-t border-gray-200" data-id="element-341">
                <span className="text-2xl font-bold" data-id="element-342">€{selectedDigitaal}</span>
                <Button variant="primary" size="medium" rightIcon={<ArrowRight size={16} data-id="element-344" />} data-id="element-343">
                  Bestellen
                </Button>
              </div>
            </CardContent>
          </Card>

          {/* Fysieke bon */}
          <Card variant="outlined" data-id="element-345">
            <CardContent data-id="element-346">
              <div className="border-b border-dashed border-gray-200 h-44 -mx-4 -mt-4 mb-6 flex items-center justify-center bg-gray-50 rounded-t-lg" data-id="element-347">
                <Package size={40} className="text-gray-300" data-id="element-348" />
              </div>
              <h3 className="text-xl font-bold mb-2" data-id="element-349">Fysieke cadeaubon</h3>
              <p className="text-sm text-gray-600 mb-6" data-id="element-350">
                Een mooi vormgegeven bon op papier, verpakt in een envelop.
                Ophalen in De Maekerij of per post verstuurd (+ €2,50
                verzendkosten). Perfect om persoonlijk te overhandigen.
              </p>

              <div className="mb-4" data-id="element-351">
                <span className="text-sm font-medium text-gray-700 block mb-2" data-id="element-352">
                  Kies een bedrag
                </span>
                <div className="flex flex-wrap gap-2" data-id="element-353">
                  {amounts.map(amount => <button key={amount} onClick={() => setSelectedFysiek(amount)} className={`px-4 py-2 rounded-md text-sm font-medium border transition-colors duration-150 focus:outline-none ${selectedFysiek === amount ? 'bg-gray-800 text-white border-gray-800' : 'bg-white text-gray-700 border-gray-300 hover:bg-gray-50'}`} data-id="element-354">
                      €{amount}
                    </button>)}
                </div>
              </div>

              <div className="flex items-center justify-between pt-4 border-t border-gray-200" data-id="element-355">
                <span className="text-2xl font-bold" data-id="element-356">€{selectedFysiek}</span>
                <Button variant="primary" size="medium" rightIcon={<ArrowRight size={16} data-id="element-358" />} data-id="element-357">
                  Bestellen
                </Button>
              </div>
            </CardContent>
          </Card>
        </div>

        {/* FAQ section */}
        <MiniFAQ category="Cadeaubonnen" data-id="element-359" />
      </div>
    </div>;
}